/**
 * Class name composer.
 *
 * Combines `clsx` (handles falsy values + nested arrays) with `tailwind-merge`
 * (resolves Tailwind class conflicts like `p-2 p-4` → `p-4`). Imported as
 * `cn(...)` by every component.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
